export const DATE = 'date';
export const SKIP = 'skip';
export const CREATED_AT = 'createdAt';
export const FAILED_PDF_QUERY = 'FailedPdfImports';
export const CONTROL_CODE = 'controlCode';
export const FILENAME = 'filename';
export const IS_UNRESOLVABLE = 'isUnresolvable';
export const FORM_VERSION = 'formVersion';
